import React from 'react';
import {Tooltip, Image} from 'antd';
import {getFoodStatusColor, makeCamelCase} from "../utils/Common";
import {constants, FOOD_MENU} from "../constant/constants";


function FoodItemComponent({record, callback, onEdit, headerTitle}) {
    let color = getFoodStatusColor(record.status);
    let dot = {background: color}
    let dotText = { color }
        
    const onEditClick = () => {
      onEdit(record);
    };

    const viewFood = () => {
        callback(record, constants.FOOD.VIEW)
    }
    const publishFood = () => {
        callback(record, constants.FOOD.ACTIVE)
    }
    const hideFood = () => {
        callback(record, constants.FOOD.INACTIVE)
    }
    return (
        <div className="w-full flex flex-row mb-[16px] font-uregular py-[16px] px-[24px] rounded bg-white items-center">
            <div className="w-[5%]">
                <Image
                    width={48}
                    height={48}
                    src={record.image}
                    fallback={'/images/tabletap.svg'}
                    preview={false}
                />
            </div>

          <div className="w-[35%] min-w-0 flex flex-col items-start flex-grow justify-center mx-[48px]">
            <div className="text-base text-preblack font-ubold break-words break-all whitespace-normal leading-snug max-w-full">
              {record.name}
            </div>
             <div className="text-sm text-purple font-uregular">{record.category}</div>
                {
                    headerTitle === FOOD_MENU.SINGLE && (
                        <div className="text-sm text-purple font-uregular">Current Stock: {record.availableQuantity}</div>
                    )
                }
            </div>

            <div className="w-[15%] flex flex-col items-start justify-center mx-[48px]">
                <div className="flex flex-row text-sm text-preblack font-ubold">
                    <div className="w-[72px]">Price:</div>
                    <div>{`${record.options['0'].price}TK`}</div>
                </div>
                <div className="flex flex-row text-sm text-preblack font-ubold">
                    <div className="w-[72px]">Discount:</div>
                    <div>{`${record.options['0'].discount}${record.options['0'].isDiscountInPercent ? "%" : "TK"}`}</div>
                </div>
            </div>

            <div className="w-[15%] flex flex-col items-start justify-center mx-[48px]">
                <div className="flex flex-row text-sm text-preblack font-uregular">
                    {record.includes.length > 0 ? (
                        <div className="flex flex-row">
                            <div className="w-[72px]">Foods:</div>
                            <div>{record.includes.length}</div>
                        </div>
                    ) : (
                        <div className="flex flex-row">
                            <div className="w-[72px]">Variants:</div>
                            <div>{record.variants.length}</div>
                        </div>
                    )}
                </div>
                <div className="flex flex-row text-sm text-preblack font-uregular">
                    <div className="w-[72px]">Add-Ons:</div>
                    <div>{record.addons.length}</div>
                </div>
            </div>

            <div className="w-[15%] flex flex-row items-center mx-[4px] xl:w-[110px] 2xl:w-[180px]">
                <div style={dot} className="w-[12px] h-[12px] rounded-[6px]"/>
                <div style={dotText} className="text-md ml-[8px]">{makeCamelCase(record.status)}</div>
            </div>

            <div className="w-[15%] flex flex-row items-center px-[8px] w-[104px]">
                <Tooltip placement="bottom" title={record.includes.length > 0 ? "View Set Menu" : "View Food"}>
                    <img 
                        onClick={viewFood} 
                        className="w-[36px] h-[36px] cursor-pointer" 
                        src={'/images/viewicon.svg'}
                    />
                </Tooltip>

                <Tooltip placement="bottom" title={record.includes.length > 0 ? "Edit Set Menu" : "Edit Food"}>
                    <img
                        onClick={() => onEditClick(record)}
                        className="w-[30px] h-[30px] ml-[1px] cursor-pointer"
                        src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/edit_user_icon.svg"}
                    />
                </Tooltip>

                {record.status === 'inactive' ? (
                    <Tooltip placement="bottom" title={record.includes.length > 0 ? "Publish Set Menu" : "Publish Food"}>
                        <img 
                            onClick={publishFood} 
                            className="w-[36px] h-[36px] cursor-pointer" 
                            src={'/images/tickicongrey.svg'}
                        />
                    </Tooltip>
                ) : (
                    <Tooltip placement="bottom" title={record.includes.length > 0 ? "Hide Set Menu" : "Hide Food"}>
                        <img 
                            onClick={hideFood} 
                            className="w-[36px] h-[36px] cursor-pointer" 
                            src={'/images/tickicon.svg'}
                        />
                    </Tooltip>
                )}

            </div>
            
        </div>
    );
}

export default FoodItemComponent;
